import "./reactive-element-BDpydG15.js";
import { state as u } from "../beacon-state.d/index.js";
import { p as n, m as i } from "./lifecycle-decorators-CUsT9aHq.js";
import { b as p } from "./query-assigned-DZ4JAxBy.js";
var S = Object.defineProperty, c = Object.getOwnPropertyDescriptor, f = (a, r, s, e) => {
  for (var t = e > 1 ? void 0 : e ? c(r, s) : r, o = a.length - 1, l; o >= 0; o--)
    (l = a[o]) && (t = (e ? l(r, s, t) : l(t)) || t);
  return e && t && S(r, s, t), t;
};
const T = ({ clean: a } = { clean: !1 }) => function(s) {
  let e = class extends s {
    /**
     * Removes any whitespace from the default slot.
     *
     * Default slots can see whitespace or new line characters as node slotted in, which can cause presentational issues when there's fallback content in the slot's position.
     *
     * This issue is commonly seen in AEM applications but can be a result of any templating syntax that doesn't trim whitespace from HTML nodes the whole way.
     */
    cleanDefaultSlot() {
      this.defaultSlotNodes.forEach((t) => {
        var o;
        !t.slot && !((o = t.textContent) != null && o.trim()) && t.remove();
      });
    }
    /** Sets internal state for slot text and existance of slot content */
    setDefaultSlotText() {
      this.defaultSlotText = this.getDefaultSlotText(), a && this.cleanDefaultSlot();
    }
    /** Grabs slotted text and sets the state defaultSlotText property. */
    getDefaultSlotText() {
      if (this.defaultSlotNodes.length > 0)
        return this.defaultSlotNodes.map((t) => {
          var o, l;
          return (l = (o = t.textContent) == null ? void 0 : o.trim()) != null ? l : "";
        }).join("");
    }
    postrenderSetDefaultSlotText() {
      this.setDefaultSlotText();
    }
  };
  return f([
    u()
  ], e.prototype, "defaultSlotText", 2), f([
    p({ flatten: !0 })
  ], e.prototype, "defaultSlotNodes", 2), f([
    n
  ], e.prototype, "postrenderSetDefaultSlotText", 1), e = f([
    i("TracksDefaultSlot")
  ], e), e;
};
export {
  T
};
